import { Suspense } from "react";
import { Outlet, useMatches } from "react-router";
import { twMerge } from "tailwind-merge";
import ContentFallback from "./ContentFallback";

type RouteHandle = { noGutters?: boolean };

export default function IndividualEntityPage() {
    // A route can specify noGutters in its handle to indicate that it wants to run edge-to-edge and pad its own columns.
    const matches = useMatches();
    const noGutters = matches.some(match => (match.handle as RouteHandle | undefined)?.noGutters === true);

    return (
        <div
            id="app-shell"
            className="grid duration-300 ease-in-out"
            style={{
                gridTemplateColumns: `auto`,
            }}
        >
            <div className="flex min-w-0 justify-stretch">
                <div id="route-content" className={twMerge("grow min-w-0 sm:h-screen sm:overflow-auto", !noGutters && "sm:px-3")}>
                    <Suspense fallback={<ContentFallback />}>
                        <Outlet />
                    </Suspense>
                </div>
            </div>
        </div>
    );
}
